// removed by extract-text-webpack-plugin
module.exports = {"button":"_1iKuopScaeZcRdYL23MsOX","raised":"ONZv6gpyFTGUus-UU5gfa","flat":"_2ui7tJsQx-GIUrilfD32Pn","floating":"_1mZ5Ei6s7FESGvXSI2ehIK","toggle":"_1Zy-oZvy13_yxXF9LjIg3K","rippleWrapper":"_2zthiDPU3XZTcayORjdOGV","icon":"_1BTd6-3_I2hyoxZRgl2EaQ","mini":"_2oXdCsHZVqvgCHqDHvxWIr","neutral":"uDC3jmklpiJdZzUIQfc1","inverse":"_2Z8iZlL18fIvGPXpHOzRC4","primary":"_2NhN1FfBw_4TnHBCweg5In","accent":"_3MS_kugJjItrDtu-zb4vIg"};


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-toolbox/lib/button/theme.scss
 ** module id = 988
 ** module chunks = 0
 **/